import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/Start.vue'
import Init from '../views/Init.vue'
import Mobile from '../views/Mobile.vue'
import Tan from '../views/Tan.vue'
import Language from '../views/Language.vue'
import Animation from '../views/Animation.vue'
import Register from '../views/Register.vue'
import Pst from '../views/Pst.vue'
import Generate from '../views/Generate.vue'
import Result from '../views/Result.vue'
import Orientation from '../views/Orientation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/index.html',
    redirect: '/'
  },
  {
    path: '/',
    name: 'animation',
    component: Animation
  },
  {
    path: '/lang',
    name: 'language',
    component: Language
  },
  {
    path: '/Start',
    name: 'Start',
    component: Start
  },
  {
    path: '/init',
    name: 'root',
    component: Init
  },
  {
    path: '/mobile-start',
    name: 'mobile',
    component: Mobile
  },
  {
    path: '/tan',
    name: 'tan',
    component: Tan
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/vip',
    name: 'pst',
    component: Pst
  },
  {
    path: '/generate',
    name: 'generate',
    component: Generate
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '/orientation',
    name: 'orientation',
    component: Orientation
  },
  {
    path: '/notsupported',
    name: "NotSupported",
    component: () => import('../views/notsupported')
  }
]

const router = new VueRouter({
  mode: 'abstract',
  //base:'/missionfuture/',
  // base: '/',
  routes
})

export default router
